import React from 'react';
import {withTranslation} from 'react-i18next';
import i18next from 'i18next';

class MetaVillaComp extends React.Component {
    componentDidMount() {
        const savedLang = window.localStorage.getItem("i18Lang");
        if (!savedLang) {
            const browserLang = (navigator.language || navigator.userLanguage).toLowerCase();
            if (browserLang.startsWith('ko')) {
            } else if (browserLang.startsWith('zh')) {
                this.changeLanguage('zh');
            } else {
                this.changeLanguage('en');
            }
        }
        require('../../common/mweb/css/index.css');
        this.addCustomStyles();
    }

    addCustomStyles = () => {
        // Add custom styles for better button appearance
        const styleId = 'metavilla-custom-styles';
        if (document.getElementById(styleId)) return;

        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = `
            .metavilla-download-btn {
                font-family: 'Noto Sans KR', Arial, sans-serif;
                transition: all 0.3s ease;
            }
            
            .metavilla-anchor-btn {
                font-family: 'Noto Sans KR', Arial, sans-serif;
                transition: all 0.3s ease;
            }
            
            .metavilla-download-btn:hover {
                background-color: rgba(255, 255, 255, 0.1) !important;
            }
            
            .metavilla-anchor-btn:hover {
                background-color: rgba(255, 255, 255, 0.15) !important;
            }
            
            .metavilla-download-btn:focus,
            .metavilla-anchor-btn:focus {
                outline: 2px solid rgba(255, 255, 255, 0.8) !important;
                outline-offset: 2px !important;
            }
        `;
        document.head.appendChild(style);
    }

    changeLanguage = (lang) => {
        i18next.changeLanguage(lang);
    };

    scrollToPokedex = () => {
        const pokedexElement = document.getElementById('pokedex');
        if (pokedexElement) {
            pokedexElement.scrollIntoView({ behavior: 'smooth' });
        }
    };

    handleDownload = (fileName) => {
        const url = `https://981park-jeju-asset.s3.ap-northeast-2.amazonaws.com/www/common/mweb/img/sub/event/${fileName}.jpg`;

        // Create a temporary link element for download
        const link = document.createElement('a');
        link.href = url;
        link.download = `${fileName}.jpg`;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';

        // Append to body, click, and remove
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    renderDownloadButtons = (imageName) => {
        let downloadableImages = [];

        if (imageName === 'img-metavilla7_2') {
            downloadableImages = [
                { id: 'download-1', top: '0%', left: '15%', width: '70%', height: '100%', fileName: 'download-metavilla-1' },
            ];
        } else if (imageName === 'img-metavilla7_4') {
            downloadableImages = [
                { id: 'download-2', top: '0%', left: '15%', width: '70%', height: '100%', fileName: 'download-metavilla-2' },
            ];
        } else if (imageName === 'img-metavilla7_6') {
            downloadableImages = [
                { id: 'download-3', top: '0%', left: '15%', width: '70%', height: '100%', fileName: 'download-metavilla-3' },
            ];
        } else if (imageName === 'img-metavilla7_8') {
            downloadableImages = [
                { id: 'download-4-left', top: '0%', left: '15%', width: '34.4%', height: '100%', fileName: 'download-metavilla-4' },
                { id: 'download-5-right', top: '0%', left: '50.5%', width: '34.6%', height: '100%', fileName: 'download-metavilla-5' },
            ];
        }

        return downloadableImages.map((imageArea) => (
            <button
                key={imageArea.id}
                className="metavilla-download-btn"
                onClick={() => this.handleDownload(imageArea.fileName)}
                style={{
                    position: 'absolute',
                    top: imageArea.top,
                    left: imageArea.left,
                    width: imageArea.width,
                    height: imageArea.height,
                    cursor: 'pointer',
                    zIndex: 20,
                    backgroundColor: 'transparent',
                    border: 'none',
                    borderRadius: '0',
                    color: 'transparent',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    transition: 'all 0.3s ease',
                    padding: '0',
                    outline: 'none'
                }}
                onMouseEnter={(e) => {
                    e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                    e.target.style.transform = 'scale(1.02)';
                }}
                onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.transform = 'scale(1)';
                }}
                onFocus={(e) => {
                    e.target.style.outline = '2px solid rgba(255, 255, 255, 0.8)';
                    e.target.style.outlineOffset = '2px';
                }}
                onBlur={(e) => {
                    e.target.style.outline = 'none';
                    e.target.style.outlineOffset = '0';
                }}
                aria-label={`${imageArea.buttonText} - 이미지를 다운로드합니다`}
                title={imageArea.buttonText}
            >
            </button>
        ));
    };

    render() {
        const {t} = this.props;

        // imageUrl 생성
        let imagePostfix = '.png';
        if (i18next.language === 'en') {
            imagePostfix = '_en.png';
        } else if (i18next.language === 'zh') {
            imagePostfix = '_zh.png';
        }

        const images = [
            {
                name: 'img-metavilla5',
                altKey: 'Metavilla_altText3',
                titleKey: 'Metavilla_titleText3'
            },
            {
                name: 'img-metavilla6',
                altKey: 'Metavilla_altText4',
                titleKey: 'Metavilla_titleText4'
            },
            {
                name: 'img-metavilla7_1',
                altKey: 'Metavilla_altText5',
                titleKey: 'Metavilla_titleText5'
            },
            {
                name: 'img-metavilla7_2',
                altKey: 'Metavilla_altText5',
                titleKey: 'Metavilla_titleText5'
            },
            {
                name: 'img-metavilla7_3',
                altKey: 'Metavilla_altText5',
                titleKey: 'Metavilla_titleText5'
            },
            {
                name: 'img-metavilla7_4',
                altKey: 'Metavilla_altText5',
                titleKey: 'Metavilla_titleText5'
            },
            {
                name: 'img-metavilla7_5',
                altKey: 'Metavilla_altText5',
                titleKey: 'Metavilla_titleText5'
            },
            {
                name: 'img-metavilla7_6',
                altKey: 'Metavilla_altText5',
                titleKey: 'Metavilla_titleText5'
            },
            {
                name: 'img-metavilla7_7',
                altKey: 'Metavilla_altText5',
                titleKey: 'Metavilla_titleText5'
            },
            {
                name: 'img-metavilla7_8',
                altKey: 'Metavilla_altText5',
                titleKey: 'Metavilla_titleText5'
            },
            {
                name: 'img-metavilla7_9',
                altKey: 'Metavilla_altText5',
                titleKey: 'Metavilla_titleText5'
            },
            {
                name: 'img-metavilla8',
                altKey: 'Metavilla_altText5',
                titleKey: 'Metavilla_titleText5'
            },
            {
                name: 'img-metavilla9',
                altKey: 'Metavilla_altText5',
                titleKey: 'Metavilla_titleText5'
            },
            {
                name: 'img-metavilla4',
                altKey: 'Metavilla_altText2',
                titleKey: 'Metavilla_titleText2'
            }
        ]
        const headerHeight = '54px';

        return (
            <>
                <header style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    zIndex: 1000,
                    boxSizing: 'border-box',
                    height: headerHeight,
                    backgroundColor: '#000000',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    paddingLeft: '24px',
                    paddingRight: '24px'
                }}>
                    <div className="logo" style={{display: 'flex', alignItems: 'center'}}>
                        <img
                            src="https://asset.981park.com/www/common/web/img/common/logo/981-park.svg"
                            alt="981 PARK"
                            style={{
                                width: '94.7px',
                                height: '30px',
                                cursor: 'pointer'
                            }}
                            onClick={() => window.open('https://981park.com', '_blank', 'noopener,noreferrer')}
                        />
                    </div>
                    <div style={{display: 'flex', alignItems: 'center', gap: '19px'}}>
                        <span className="typo1" style={{color: 'white', fontSize: '15px', cursor: 'pointer'}}
                              onClick={() => this.changeLanguage('ko')}>{t('Lang_ko')}</span>
                        <span className="typo1" style={{color: 'white', fontSize: '15px', cursor: 'pointer'}}
                              onClick={() => this.changeLanguage('en')}>{t('Lang_en')}</span>
                        <span className="typo1" style={{color: 'white', fontSize: '15px', cursor: 'pointer'}}
                              onClick={() => this.changeLanguage('zh')}>{t('Lang_zh')}</span>
                    </div>
                </header>

                <div className="park-wrap" style={{paddingTop: headerHeight}}>
                    <div className="info">
                        <div className="img-wrap">
                            <div className="img">
                                {images.map((image, index) => (
                                    <div key={index} style={{position: 'relative'}} id={image.name === 'img-metavilla4' ? 'pokedex' : undefined}>
                                        <img
                                            src={`https://981park-jeju-asset.s3.ap-northeast-2.amazonaws.com/www/common/mweb/img/sub/event/${image.name}${imagePostfix}`}
                                            alt={t(image.altKey)}
                                            title={t(image.titleKey)}
                                            style={{width: '100%', height: 'auto', display: 'block', verticalAlign: 'top'}}
                                            loading="lazy"
                                        />
                                        {image.name === 'img-metavilla6' && (
                                            <button
                                                className="metavilla-anchor-btn"
                                                onClick={this.scrollToPokedex}
                                                style={{
                                                    position: 'absolute',
                                                    bottom: '24%',
                                                    left: '50%',
                                                    transform: 'translateX(-50%)',
                                                    width: '80%',
                                                    height: '75%',
                                                    cursor: 'pointer',
                                                    zIndex: 15,
                                                    backgroundColor: 'transparent',
                                                    border: 'none',
                                                    borderRadius: '0',
                                                    color: 'transparent',
                                                    fontSize: 'clamp(14px, 3vw, 18px)',
                                                    fontWeight: 'bold',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    gap: '8px',
                                                    transition: 'all 0.3s ease',
                                                    padding: '8px',
                                                    outline: 'none',
                                                    textAlign: 'center',
                                                    lineHeight: '1.2'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.15)';
                                                    e.target.style.transform = 'translateX(-50%) scale(1.02)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.target.style.backgroundColor = 'transparent';
                                                    e.target.style.transform = 'translateX(-50%) scale(1)';
                                                }}
                                                onFocus={(e) => {
                                                    e.target.style.outline = '2px solid rgba(255, 255, 255, 0.8)';
                                                    e.target.style.outlineOffset = '2px';
                                                }}
                                                onBlur={(e) => {
                                                    e.target.style.outline = 'none';
                                                    e.target.style.outlineOffset = '0';
                                                }}
                                            >
                                            </button>
                                        )}
                                        {image.name === 'img-metavilla8' && (
                                            <button
                                                className="metavilla-anchor-btn"
                                                onClick={() => window.open('https://link-jeju.981park.com/link?target=main', '_blank', 'noopener,noreferrer')}
                                                style={{
                                                    position: 'absolute',
                                                    bottom: '24%',
                                                    left: '50%',
                                                    transform: 'translateX(-50%)',
                                                    width: '80%',
                                                    height: '75%',
                                                    cursor: 'pointer',
                                                    zIndex: 15,
                                                    backgroundColor: 'transparent',
                                                    border: 'none',
                                                    borderRadius: '0',
                                                    color: 'transparent',
                                                    fontSize: 'clamp(14px, 3vw, 18px)',
                                                    fontWeight: 'bold',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    gap: '8px',
                                                    transition: 'all 0.3s ease',
                                                    padding: '8px',
                                                    outline: 'none',
                                                    textAlign: 'center',
                                                    lineHeight: '1.2'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.15)';
                                                    e.target.style.transform = 'translateX(-50%) scale(1.02)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.target.style.backgroundColor = 'transparent';
                                                    e.target.style.transform = 'translateX(-50%) scale(1)';
                                                }}
                                                onFocus={(e) => {
                                                    e.target.style.outline = '2px solid rgba(255, 255, 255, 0.8)';
                                                    e.target.style.outlineOffset = '2px';
                                                }}
                                                onBlur={(e) => {
                                                    e.target.style.outline = 'none';
                                                    e.target.style.outlineOffset = '0';
                                                }}
                                            >
                                            </button>
                                        )}
                                        {image.name === 'img-metavilla9' && (
                                            <button
                                                className="metavilla-anchor-btn"
                                                onClick={() => window.open('https://naver.me/xmxIgfnU', '_blank', 'noopener,noreferrer')}
                                                style={{
                                                    position: 'absolute',
                                                    bottom: '24%',
                                                    left: '50%',
                                                    transform: 'translateX(-50%)',
                                                    width: '80%',
                                                    height: '75%',
                                                    cursor: 'pointer',
                                                    zIndex: 15,
                                                    backgroundColor: 'transparent',
                                                    border: 'none',
                                                    borderRadius: '0',
                                                    color: 'transparent',
                                                    fontSize: 'clamp(14px, 3vw, 18px)',
                                                    fontWeight: 'bold',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    gap: '8px',
                                                    transition: 'all 0.3s ease',
                                                    padding: '8px',
                                                    outline: 'none',
                                                    textAlign: 'center',
                                                    lineHeight: '1.2'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.15)';
                                                    e.target.style.transform = 'translateX(-50%) scale(1.02)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.target.style.backgroundColor = 'transparent';
                                                    e.target.style.transform = 'translateX(-50%) scale(1)';
                                                }}
                                                onFocus={(e) => {
                                                    e.target.style.outline = '2px solid rgba(255, 255, 255, 0.8)';
                                                    e.target.style.outlineOffset = '2px';
                                                }}
                                                onBlur={(e) => {
                                                    e.target.style.outline = 'none';
                                                    e.target.style.outlineOffset = '0';
                                                }}
                                            >
                                            </button>
                                        )}
                                        {(image.name === 'img-metavilla7_2' ||
                                          image.name === 'img-metavilla7_4' ||
                                          image.name === 'img-metavilla7_6' ||
                                          image.name === 'img-metavilla7_8') && this.renderDownloadButtons(image.name)}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default withTranslation()(MetaVillaComp);
